import { render, staticRenderFns } from "./ConfigTextToSpeechSpeedList.vue?vue&type=template&id=0539c0a0&scoped=true"
import script from "./ConfigTextToSpeechSpeedList.vue?vue&type=script&lang=js"
export * from "./ConfigTextToSpeechSpeedList.vue?vue&type=script&lang=js"
import style0 from "./ConfigTextToSpeechSpeedList.vue?vue&type=style&index=0&id=0539c0a0&prod&scoped=true&lang=css"
import style1 from "./ConfigTextToSpeechSpeedList.vue?vue&type=style&index=1&id=0539c0a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0539c0a0",
  null
  
)

export default component.exports